<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <span *ngIf="!isDraft"
                              class="njoy-title card-title float-start">{{ 'PARTNER.DETAILS_LABEL' | translate }}</span>
                        <span *ngIf="isDraft"
                              class="njoy-title card-title float-start">{{ 'PARTNER.DRAFT_DETAIL_PARTNER' | translate }}</span>
                        <span class="card-title float-right" (click)="confirmChangeDraftStatus()">
                                <ng-container *ngIf="isDraft">
                                {{ 'PARTNER.PUBLISH' | translate }}
                                </ng-container>
                                <ng-container *ngIf="!isDraft">
                                {{ 'PARTNER.MAKE_DRAFT' | translate }}
                                </ng-container>
                        </span>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="partnerForm" (ngSubmit)="updatePartner()">
                            <div class="row">
                                <div class="col-md-3">
                                    <mat-label>{{ 'CLIENT.LASTNAME_LABEL' | translate }} *</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="name"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.name?.errors?.required">
                                            {{ 'CLIENT.LASTNAME_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'PARTNER.USERNAME_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="username" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <mat-label>{{ 'PARTNER.UUID' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="uuid" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'PARTNER.WEBSITE_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="website" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'CLIENT.PHONE_NUMBER' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="phoneNumber" (keypress)="validatePhoneNumber($event)"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.phoneNumber?.errors?.required">
                                            {{ 'CLIENT.PHONE_NUMBER_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <mat-label>{{ 'PARTNER.TAGS' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <mat-select formControlName="tag">
                                            <mat-option *ngFor="let tag of tags" [value]="tag.uuid">
                                                {{tag.label}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <mat-label>{{ 'PARTNER.OLD_ID_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="oldId"
                                               [errorStateMatcher]="matcher" type="number">
                                        <mat-error
                                                *ngIf="getControl?.oldId?.errors?.min || getControl?.oldId?.errors?.pattern">
                                            {{ 'PARTNER.OLD_ID_ERROR_LABEL' | translate }}
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-error style="font-size: 75%;" *ngIf="oldPartnerIdExists">
                                        {{ 'PARTNER.OLD_PARTNER_EXISTS_ERROR_LABEL' | translate }}
                                    </mat-error>
                                </div>
                                <div class="col-md-2 partner-checkbox">
                                    <mat-label>{{ 'PARTNER.COUP_DE_COEUR' | translate }}</mat-label>
                                    <mat-checkbox class="example-margin ml-4"
                                                  formControlName="heartstroke">
                                    </mat-checkbox>
                                </div>
                                <div class="col-md-2 partner-checkbox">
                                    <mat-label>{{ 'PARTNER.POPULAR' | translate }}</mat-label>
                                    <mat-checkbox class="example-margin ml-4"
                                                  formControlName="popular">
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row ml-1 mb-4 mt-2">
                                <div *ngIf="!displayEmoji">
                                    {{ 'CATEGORY.EMOJI' | translate }} * <span class="ml-2 emoji" style="font-size: 30px"
                                                                               [innerHTML]="sanitizer.bypassSecurityTrustHtml(getControl?.emoji?.value)"></span>
                                    <div *ngIf="isEmojiPickerVisible">
                                        <emoji-mart class="emoji-mart" (emojiSelect)="addEmoji($event)"
                                                    [i18n]="emojiPickerLabels"></emoji-mart>
                                    </div>
                                </div>
                                <div *ngIf="displayEmoji">
                                    {{ 'CATEGORY.EMOJI' | translate }} * <span class="ml-2 emoji" style="font-size: 30px"
                                                                               (click)="openEmojiPicker()"
                                                                               [innerHTML]="sanitizer.bypassSecurityTrustHtml(getControl?.emoji?.value)"></span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 mb-3">
                                    <mat-label class="mr-5">{{ 'PARTNER.MAIN_CATEGORY_LABEL' | translate }}*
                                    </mat-label>
                                    <p-dropdown id="categoriesSelect" class="row ml-0" [options]="categories"
                                                formControlName="mainCategory"
                                                (onChange)="setRemainingCategories($event,true)"
                                                optionLabel="displayedValue"></p-dropdown>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <mat-label class="mr-5">{{ 'PARTNER.SECONDARY_CATEGORY_LABEL' | translate }}
                                    </mat-label>
                                    <p-multiSelect id="categoriesMultiselect" class="row ml-0"
                                                   [options]="remaingCategory"
                                                   (onChange)="setRemainingCategories($event,false)"
                                                   formControlName="secondaryCategory"
                                                   optionLabel="displayedValue" display="chip"></p-multiSelect>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <mat-label class="mr-5">{{ 'CLIENT.MAIN_TAGS_LABEL' | translate }}</mat-label>
                                    <p-multiSelect [options]="mainPreferences" formControlName="mainPreferences"
                                                   (onChange)="setRemainingTags(false)"
                                                   optionLabel="displayedValue" optionValue="value" dataKey="value"
                                                   display="chip"></p-multiSelect>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <mat-label class="mr-5">{{ 'CLIENT.SECONDARY_TAGS_LABEL' | translate }}</mat-label>
                                    <p-multiSelect [options]="secondaryPreferences"
                                                   formControlName="secondaryPreferences"
                                                   (onChange)="setRemainingTags(true)"
                                                   optionLabel="displayedValue" optionValue="value" dataKey="value"
                                                   display="chip"></p-multiSelect>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <mat-label>{{ 'CLIENT.ADDRESS_LABEL' | translate }}*</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="streetAddress"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.streetAddress?.errors?.required">
                                            {{ 'PARTNER.ADDRESS_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-error style="font-size: 75%;" *ngIf="addressNotFound">
                                        {{ 'PARTNER.ADDRESS_NOT_FOUND_ERROR' | translate }}
                                    </mat-error>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <mat-label>{{ 'CLIENT.CITY_LABEL' | translate }}*</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="city"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.city?.errors?.required">
                                            {{ 'PARTNER.CITY_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-label>{{ 'CLIENT.COUNTRY_LABEL' | translate }}*</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <mat-select formControlName="country">
                                            <ng-container *ngIf="this.localizationService.getLanguage() === 'fr-FR'">
                                                <mat-option *ngFor="let country of countries" [value]="country.uuid">
                                                    {{country.libelleFR}}
                                                </mat-option>
                                            </ng-container>
                                            <ng-container *ngIf="this.localizationService.getLanguage() === 'en-US'">
                                                <mat-option *ngFor="let country of countries" [value]="country.uuid">
                                                    {{country.libelleEN}}
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-label>{{ 'CLIENT.ZIPCODE_LABEL' | translate }}*</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <input matInput formControlName="zipCode"
                                               [errorStateMatcher]="matcher" type="text">
                                        <mat-error *ngIf="getControl?.zipCode?.errors?.required">
                                            {{ 'PARTNER.ZIPCODE_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <mat-label class="mr-5">{{ 'PARTNER.KEYWORDS_LABEL' | translate }}</mat-label>
                                    <p-chips formControlName="keywords" separator=","></p-chips>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <mat-label>{{ 'PARTNER.DESCRIPTION_LABEL' | translate }}</mat-label>
                                    <mat-form-field class="example-full-width">
                                        <textarea matInput formControlName="description"
                                                  (ngModelChange)="setRemainingCharsValue()" rows="5"></textarea>
                                        <span class="remaning">{{remainingText}}</span>
                                        <mat-error *ngIf="getControl?.description?.errors?.required">
                                            {{ 'PARTNER.DESCRIPTION_REQUIRED_ERROR_LABEL' | translate }}
                                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                                        </mat-error>
                                        <mat-error *ngIf="getControl?.description?.errors?.maxlength">
                                            {{ 'PARTNER.DESCRIPTION_MAX_LENGTH_ERROR_LABEL' | translate }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <button mat-raised-button type="submit"
                                    class="btn btn-danger pull-right">{{ 'BUTTONS.SAVE' | translate }}
                            </button>
                            <div class="clearfix"></div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="logo-container" (click)="openFileUploader()">
                                    <img [src]="partner?.imagePath" class="big-logo"
                                         *ngIf="partner && partner.imagePath"
                                         [title]="clickToUpdateTitle"/>
                                    <img src="assets/icons/shared/image-not-found.png" alt="" class="big-logo"
                                         *ngIf="!partner || !partner.imagePath">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="logo-container">
                                    <img [src]="partner?.qrCodePath" class="big-logo"
                                         *ngIf="partner && partner.qrCodePath"/>
                                    <img src="assets/icons/shared/image-not-found.png" alt="" class="big-logo"
                                         *ngIf="!partner || !partner.qrCodePath">
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">{{ 'OFFERS.TABLE_TITLE' | translate }} {{partner?.name}}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <njoy-offres [selectedPartner]="partner"></njoy-offres>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-fileUpload (onSelect)="uploadImage()"
              [hidden]="true" [showCancelButton]="false"
              [showUploadButton]="false"
              accept="image/*"
              mode="basic"
              name="partnerImageUploader">
</p-fileUpload>

<p-confirmDialog key="brouillonCd" #brouillonCd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="{{ 'BUTTONS.YES' | translate }}"
                (click)="brouillonCd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="{{ 'BUTTONS.NO' | translate }}"
                (click)="brouillonCd.reject()"></button>
    </ng-template>
</p-confirmDialog>

